export default {
    getLorryTrailers: state => state.lorryTrailers,
    getTruckTrailers: state => state.truckTrailers,
    getPickupTrailers: state => state.pickupTrailers,
    trailerDetails: state => state.truckTrailers?.concat(
        state.lorryTrailers
    )?.concat(
        state.pickupTrailers
    )
}